type Props = {
  height?: string;
  stroke?: string;
  width?: string;
};

const SortIcon = ({
  height = '24',
  stroke = 'currentColor',
  width = '24'
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 20V4M8 4L4 8M8 4L12 8"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 4V20M16 20L12 16M16 20L20 16"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SortIcon;
